import { isEmpty, filter } from 'lodash';

export function getCatQuizSolved(state, getters) {
  return !isEmpty(getters.getCatQuizResult) ||
    !isEmpty(state.catQuizResults[getters.getCatPagePosition]);
}

export function getCatQuizResult(state, getters) {
  return getters.getCatQuizResults && getters.getCatQuizResults[getters.getCatPagePosition - 1];
}

export function getCatQuizQuizSubmissionDate(state, getters) {
  return getters.getCatQuizResult && getters.getCatQuizResult.updated_at;
}

export function getCatQuizResultPageId(state, getters) {
  return (getters.getCatQuizResult && getters.getCatQuizResult.page_id) ||
    (getters.getCatPagesIdList && getters.getCatPagesIdList[getters.getCatPagePosition - 1]);
}

export function getCatQuizResults(state, getters) {
  if (getters.getCatQuizWrongResults && getters.getCatQuizWrongResults.length > 0) {
    return getters.getCatQuizWrongResults;
  }

  return getters.getCatQuizCompleted;
}

export function getCatQuizCompleted(state) {
  return state.catQuizResults || [];
}

export function getCatQuizCount(state, getters) {
  return getters.getCatQuizResults[getters.getCatPagePosition - 1] &&
    getters.getCatQuizResults[getters.getCatPagePosition - 1].position;
}

export function getQuizWrongResultsFilter(state, getters) {
  return filter(getters.getCatQuizCompleted, item => (
    item.is_correct === false
  ));
}
